<script>
import moment from "moment";
import PagenationContainer from "@/components/common/PagenationContainer.vue";
export default {
  components: {
    PagenationContainer
  },
  props: {
    patientId: undefined,
    singleGames: Number,
  },
  watch: {
    singleGames: function(newVal, oldVal) {
      this.singleGames = newVal
      this.maxCount = this.singleGames
      // this.handleChange()
      console.log("singleGames change:" + oldVal + "->" + newVal);
    },
    patientId: function(newVal, oldVal) {
      this.patientId = newVal;
      console.log("singleGames change:" + oldVal + "->" + newVal);
    }
  },
  created() {
    this.loadMyGamesData()
    this.loadGameList()
  },
  mounted(){
    console.log("mounted...")
  },
  data() {
    return {
      gameRefundWinShowFlag: false,
      exercisePlanShowFlag: false,
      gameFormEditShowFlag: false,
      remainCount: 0,
      totalCount: 0,
      gameNumberStart: undefined,
      gameNumberEnd: undefined,
      remainCount: 0,
      maxCount:0,
      myGameList: [],
      gameList:[],
      gameCategories: [],
      games:[],
      resetId: '',
      gameEditForm: {id:'', level:'', category:'', gameId:''},
      gameFormArray:[
        {label: "分类", keyName: "category", type: "select", event: "categoryChange", children: []},
        {label: "训练", keyName: "gameId", type: "select", children: []},
        {label: "级别", keyName:"level", type: "number"}
      ],
      refundForm: {
        game: '',
        gameId: '',
        quantity: '',
        unitPrice: '',
        paymentFlag: true,
        type: 'REFUND',
        player: '',
        total: 0,
        stationId: this.$cookie.get("stationId")
      },
      formCount: {
        jingxiciji: 0,
        shijuejiqiao: 0,
        gabor: 0,
        duibimingandu: 0,
        xinxitiqu: 0,
        rongheshi: 0,
        tongshishi: 0,
        litishi: 0,
      },
      levelControl: {
        max: 0,
        min: 0,
        begin: 0,
        end: 0,
      },
      currentPage: 1,
      pageCount: 0,
      pageSize: 50,
      totalElements: 0
    }
  },
  methods: {
    async loadMyGamesData() {
      const result = await this.$http.getMyGames(
        {patientId: this.patientId, size: this.pageSize, page: this.currentPage - 1}
      );
      this.myGameList = result.content;
      this.pageCount = result.totalPages;
      this.totalElements = result.totalElements;
    },
    async loadGameList() {
      const games = [];
      let list = await this.$http.getGames();
      let labels = [];
      this.gameCategories = [];
      list.forEach((item) => {
        games.push({label: item.name, value: item.id})
        if (!labels.includes(item.label)) {
          labels.push(item.label)
          this.gameCategories.push({label: item.labelName, value: item.label})
        }
      });
      
      this.games = games;
      this.gameList = list;
    },
    categoryChange(val) {
      console.log("val:"+val)
      let games = []
      this.gameList.forEach((item) => {
        if (item.label==val) {
          games.push({label: item.name, value: item.id})
        }
      });
      this.games = games
      this.gameEditForm.gameId = this.games.length==1 ? this.games[0].value : ''
    },
    handleRefund(row) {
      this.refundForm.game = row.game
      this.refundForm.gameId = row.gameId
      this.refundForm.quantity = row.quantity
      this.refundForm.player = row.player
      this.refundForm.unitPrice = row.unitPrice
      this.refundForm.total = 0
      this.refundForm.quantity = 1
      this.gameRefundWinShowFlag = true
    },
    async refundSale() {
      let result = await this.$http.saleAGame(this.refundForm);
      this.gameRefundWinShowFlag = false
    },
    valuation() {
      if (this.refundForm.quantity == '' || this.refundForm.unitPrice == '') {
        this.refundForm.total = 0;
        return 
      }
      this.refundForm.total = (Math.round(this.refundForm.unitPrice * 100) * this.refundForm.quantity) / 100
    }, 
    exercisePlanDialogShow() {
      this.exercisePlanShowFlag = true
      this.formCount.jingxiciji = 0
      this.formCount.shijuejiqiao = 0;
      this.formCount.gabor = 0
      this.formCount.duibimingandu = 0
      this.formCount.xinxitiqu = 0
      this.formCount.rongheshi = 0
      this.formCount.tongshishi = 0
      this.formCount.litishi = 0
      this.handleChange()
    },
    exercisePlanDialogClose(){
         this.exercisePlanShowFlag = false
    },
    handleChange(type) {
      console.log("handleChange:" + type)
      if (this.maxCount == 0) {
        this.maxCount = this.singleGames
      }
      let totalCount = 0;
      for (let item in this.formCount) {
        let v = this.formCount[item];
        if (v == undefined) v = 0;
        totalCount += v;
      }
      this.totalCount = totalCount
      if (totalCount > this.singleGames) {
        this.$message.error("请确认计划的次数总和不能超过患者已购买的单次购买总数！");
        return;
      }
      this.remainCount = this.singleGames - totalCount
    },
    async exercisePlan() {
      console.log("exercisePlan")
      if (this.totalCount > this.singleGames) {
        this.$message.error("请确认计划的次数总和不能超过患者已购买的单次购买总数！");
        return;
      }
      let postData = {
        patientId: this.patientId,
        jingxiciji: this.formCount.jingxiciji,
        shijuejiqiao: this.formCount.shijuejiqiao,
        gabor: this.formCount.gabor,
        duibimingandu: this.formCount.duibimingandu,
        xinxitiqu: this.formCount.xinxitiqu,
        rongheshi: this.formCount.rongheshi,
        tongshishi: this.formCount.tongshishi,
        litishi: this.formCount.litishi
      }
      const result = await this.$http.exercisePlan(postData)
      if (result.code === 200) {
        this.$message.success("操作成功！")
        this.loadMyGamesData();
        this.exercisePlanShowFlag = false
        this.$emit('singleGamesChange',this.remainCount)
      }
    },
    handleReset(row) {
      if (row.status=='PENDING') {
        this.$message.error("此训练未开始，无需重置！");
        return;
      }
      this.$confirm('确认要重置此训练吗?', '训练重置', {
              cancelButtonText: '取消',
              confirmButtonText: '确定',
              type: 'warning',
              center: true
            }).then(() => {
              this.onPlanReset(row.id)
            }).catch((e) => {
              this.$message({
                type: 'info',
                message: '重置失败！'
              })
            });
    },
    async onPlanReset(id) {
      let re = await this.$http.singlePlanReset({id:id})
      if (re == 'success') {
        this.loadMyGamesData()
      }
    },
    handleEdit(row) {
      if (row.status!='PENDING') {
        this.$message.error("此训练已经被执行，无法编辑！");
        return;
      }
      this.categoryChange(row.label)
      this.gameFormEditShowFlag = true
      this.gameEditForm.id = row.id
      this.gameEditForm.gameId = row.gameId
      this.gameEditForm.category = row.labelName
      this.gameEditForm.level = row.level
    },
    async onPlanEdit()  {
      if(this.gameEditForm.gameId == '') {
        this.$message.warning("请选择一个训练！")
        return
      }
      let re = await this.$http.singlePlanEdit(this.gameEditForm)
      if (re == 'success') {
        this.gameFormEditShowFlag = false
        this.$message.success("操作成功！")
        this.loadMyGamesData()
      }
    },
    handleDelete(row) {
      if (row.status!='PENDING') {
        this.$message.error("此训练已经被执行，无法删除！");
        return;
      }
      this.$confirm('确认要删除此训练吗?', '删除训练', {
              cancelButtonText: '取消',
              confirmButtonText: '确定',
              type: 'warning',
              center: true
            }).then(() => {
              this.onPlanDelete(row.id)
            }).catch((e) => {
              console.log(e)
              this.$message({
                type: 'info',
                message: '删除失败！'
              })
            });
    },
    async onPlanDelete(id) {
      let re = await this.$http.singlePlanDelete({id:id})
      if (re == 'success') {
        this.loadMyGamesData()
        this.$emit('singleGamesChange',this.singleGames + 1)
      }
    }, 
    async deletePending() {
      this.$confirm('此操作将删除患者所有未执行的训练计划，是否继续?', '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          console.log("confirmed")
          this.onDeletePendingPlan()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    async onDeletePendingPlan() {
      let re = await this.$http.deleteAllPlanNoPlay({playerId:this.patientId})
      if (re.code == 200 && re.data > 0) {
        this.$message({
            type: 'success',
            message: '删除成功!'
        });
        this.loadMyGamesData()
        this.$emit('singleGamesChange',this.singleGames + re.data)
      } else {
        this.$message({
            type: 'error',
            message: '删除失败!'
        });
      }
    },    
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadMyGamesData();
    },
    showResult(row) {
      var res = "-" 
      if (row.status == 'PENDING') {
        return res
      }
      res = ""
      if (row.clientType && row.clientType != null) {
        res += "客户端：" 
        if (row.clientType == 'ANDROID_PAD') {
          res += "Android Pad"
        } else if (row.clientType == 'IPAD') {
          res += "iPad"
        } else if (row.clientType == 'WINDOWS_PAD') {
          res += "Windows Pad"
        } else if (row.clientType == 'WINDOWS_CLIENT') {
          res += "Windows 客户端"
        } else if (row.clientType == 'WINDOWS_WEB') {
          res += "Windows 浏览器"
        } else if (row.clientType == 'MAC_CLIENT') {
          res += "MAC 客户端"
        } else if (row.clientType == 'MAC_WEB') {
          res += "MAC 浏览器"
        } else if (row.clientType == 'CLIENT') {
          res += "客户端"
        } else {
          res += "浏览器"
        }
      }
      console.log("1res:" + res)
      if (row.clientVersion && row.clientVersion != null) {
        if (res.length>0) {
          res += "，"
        }
        res += "版本：" + row.clientVersion
      }
      console.log("2res:" + res)
      if (row.begin && row.begin != null) {
        if (res.length > 0) {
          res += "，"
        }
        res += "开始时间：" + moment(row.begin).format("YYYY-MM-DD HH:mm:ss")
      }
      console.log("3res:" + res)
      if (row.end && row.end != null) {
        if (res.length > 0) {
          res += "，"
        }
        res += "完成时间：" + moment(row.end).format("YYYY-MM-DD HH:mm:ss")
      }
      return res
    }
  }
};
</script>

<template>
  
  <div class="PatientTrainHistoryIndex">
    <el-dialog
  title="单次训练购买退货"
  width="30%" :visible.sync="gameRefundWinShowFlag">
      <el-form :model="refundForm">
        <el-form-item label = "训练名">
        <el-input v-model="refundForm.game" autocomplete="off" :readonly = true ></el-input>
        </el-form-item>
        <el-form-item label="退货数量">
        <el-input-number v-model="refundForm.quantity" :min="1" @change="valuation"></el-input-number>
        </el-form-item>
        <el-form-item label="退货单价">
        <el-input-number v-model="refundForm.unitPrice" :min="0" @change="valuation"></el-input-number>
        </el-form-item>
        <el-form-item label = "小计">
        <el-input v-model="refundForm.total" autocomplete="off" :readonly = true ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="gameRefundWinShowFlag = false">取 消</el-button>
        <el-button type="primary" @click="refundSale">确 定</el-button>
      </span>
    </el-dialog>
    <operationDialog
      class="editCourseDialog"
      title="单次训练计划"
      :Visible="exercisePlanShowFlag"
      width="576px"
      :center="true"
      @close="exercisePlanDialogClose"
      @confirm="exercisePlan"
      btnText="确定"
    >
      <span class="noticeItem">
        <i class="el-icon-warning warinigIcon"></i>共{{singleGames}}次的训练, 已安排{{ totalCount }}次, 剩余{{ remainCount }}
      </span>
      <div class="line"></div>
      <el-row :gutter="24">
        <el-col :span="4">
          <div class="item">训练次数</div>
        </el-col>
        <el-col :span="4">
          <span class="item">精细刺激</span>
        </el-col>
        <el-col :span="6">
          <el-input-number
            v-model="formCount.jingxiciji"
            class="dialogNumberInput"
            key="jingxiciji"
            controls-position="right"
            size="mini"
            :min="0"
            :max="maxCount"
            @change="handleChange('jingxiciji')"
          ></el-input-number>
        </el-col>
        <el-col :span="4">
          <span class="item">视觉技巧</span>
        </el-col>
        <el-col :span="5">
          <el-input-number
            v-model="formCount.shijuejiqiao"
            class="dialogNumberInput"
            controls-position="right"
            @change="handleChange('shijuejiqiao')"
            :min="0"
            :max="maxCount"
            size="mini"
            key="shijuejiqiao"
          ></el-input-number>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="4" :offset="4">
          <span class="item">Gabor</span>
        </el-col>
        <el-col :span="6">
          <el-input-number
            v-model="formCount.gabor"
            key="gabor"
            class="dialogNumberInput"
            controls-position="right"
            @change="handleChange('gabor')"
            :min="0"
            :max="maxCount"
            size="mini"
          ></el-input-number>
        </el-col>
        <el-col :span="4">
          <span class="item">对比敏感度</span>
        </el-col>
        <el-col :span="5">
          <el-input-number
            v-model="formCount.duibimingandu"
            class="dialogNumberInput"
            controls-position="right"
            key="duibimingandu"
            @change="handleChange('duibimingandu')"
            :min="0"
            :max="maxCount"
            size="mini"
          ></el-input-number>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="4" :offset="4">
          <span class="item">信息提取</span>
        </el-col>
        <el-col :span="6">
          <el-input-number
            v-model="formCount.xinxitiqu"
            class="dialogNumberInput"
            key="xinxitiqu"
            controls-position="right"
            @change="handleChange('xinxitiqu')"
            :min="0"
            :max="maxCount"
            size="mini"
          ></el-input-number>
        </el-col>
        <el-col :span="4">
          <span class="item">融合视</span>
        </el-col>
        <el-col :span="5">
          <el-input-number
            v-model="formCount.rongheshi"
            key="rongheshi"
            class="dialogNumberInput"
            controls-position="right"
            @change="handleChange('rongheshi')"
            :min="0"
            :max="maxCount"
            size="mini"
          ></el-input-number>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="4" :offset="4">
          <span class="item">同时视</span>
        </el-col>
        <el-col :span="6">
          <el-input-number
            v-model="formCount.tongshishi"
            class="dialogNumberInput"
            key="tongshishi"
            controls-position="right"
            @change="handleChange('tongshishi')"
            :min="0"
            :max="maxCount"
            size="mini"
          ></el-input-number>
        </el-col>
        <el-col :span="4">
          <span class="item">立体视</span>
        </el-col>
        <el-col :span="5">
          <el-input-number
            v-model="formCount.litishi"
            class="dialogNumberInput"
            key="litishi"
            controls-position="right"
            @change="handleChange('litishi')"
            :min="0"
            :max="maxCount"
            size="mini"
          ></el-input-number>
        </el-col>
      </el-row>
    </operationDialog>
    <el-dialog
      title="训练编辑"
      :visible.sync="gameFormEditShowFlag"
      width="30%">
      <el-form :model="gameEditForm" ref="gameEditForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="分类">
          <el-select v-model="gameEditForm.category" placeholder="请选择分类" @change="categoryChange">
            <el-option
              v-for="item in gameCategories"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item >
        <el-form-item label="训练">
          <el-select v-model="gameEditForm.gameId" placeholder="请选择训练">
            <el-option
              v-for="item in games"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关卡">
          <el-input-number v-model="gameEditForm.level" :min="1" :max="100" label="起始关卡"></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="gameFormEditShowFlag = false">取 消</el-button>
        <el-button type="primary" @click="onPlanEdit">确 定</el-button>
      </span>
    </el-dialog>

    <span class="trainPlanRight">
      <el-button
        v-if="singleGames>0"
        size="medium"
        @click="exercisePlanDialogShow"
        class="addEditRangeButton"
        >单次训练计划</el-button>
        <el-button type="text" @click="deletePending">一键删除</el-button>
    </span>
    <el-table
      :data="myGameList"
      class="AgencyAccountTable"
      :header-cell-style="{ 'padding-left': '5px',color: 'rgba(0,0,0,0.65)','font-size': '14px', 'background-color': '#fafafa !important'}"
      :cell-style="{'padding-left': '5px'}"
    >
      <el-table-column prop="labelName" align="left" label="分类" min-width="100"></el-table-column>
      <el-table-column prop="game" align="left" label="训练名称" min-width="100"></el-table-column>
      <el-table-column prop="level" align="left" label="初始关卡" min-width="80"></el-table-column>
      <el-table-column :formatter="showResult" align="left" label="训练情况" min-width="200"></el-table-column>
      <el-table-column
        prop="operation"
        align="left"
        label="操作"
        :width="200"
      >
      <template slot-scope="scope">
        <el-button v-if="scope.row.status == 'PENDING'" @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
        <el-button v-if="scope.row.resetEnabled" @click="handleReset(scope.row)" type="text" size="small">重置</el-button>
        <el-button v-if="scope.row.status == 'PENDING'" @click="handleDelete(scope.row)" type="text" size="small">删除</el-button>
      </template>
      </el-table-column>
    </el-table>
    <PagenationContainer v-if="pageCount > 1">
        <el-pagination :current-page="currentPage" @current-change="handleCurrentChange" :page-count="pageCount" background layout=" prev, pager, next, jumper" />
    </PagenationContainer>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.PatientTrainHistoryIndex {
  .trainHistoryTable {
    margin: 20px auto;
    border: 1px;
    width: 98%;
    position: unset;
    overflow: unset;

    .checkBoxLabel {
      color: #303133;

      .el-checkbox__input.is-disabled + span.el-checkbox__label {
        color: #303133;
      }
    }

    .el-table__body tr:hover > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }

    .el-table__body tr.current-row > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }

    .el-table__header-wrapper,
    .el-table__footer-wrapper {
      position: sticky;
      top: 0;
      z-index: 500;
    }

    .trainTitleCell {
      // line-height: 20px;
      // margin-bottom: -10px;
      padding: 0;
    }

    .trainHistorListHeaderCell {
      padding-left: 0px;
      padding-right: 0px;
      color: rgba(0, 0, 0, 0.65);
      font-size: 14px;
      background-color: #fafafa !important;

      > .cell {
        padding-left: 0px;
        padding-right: 0px;
      }
    }

    .trainHistorListBodyCell {
      > .cell {
        padding-left: 0px;
        padding-right: 0px;
      }
    }
  }
  .forgetStimulusLevelAlert {
    display: inline-block;
    // width: 250px;
    // margin-top: 10px;
    border-color: #e6a23c !important;
    height: 36px;
    margin-left: 10px;
    background-color: #e6a23c !important;
    color: #fff;
    border-radius: 5px !important;
  }
  .editDialog {
    .el-dialog__body {
      padding-left: 5px;
      padding-bottom: 5px;
      padding-top: 10px;
      max-height: 350px;
      overflow-y: auto;
    }

    .existUserDialogAlert {
      margin: 15px;
      width: auto;
      // padding-left: 10px;
      height: 36px;
      background: rgba(255, 251, 230, 1);
      border-radius: 4px;
      border: 1px solid rgba(255, 229, 143, 1);

      .el-alert__title {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
        line-height: 22px;
      }
    }

    .el-row {
      line-height: 33px;
      margin: 5px 15px;
    }

    .operationDialog .el-dialog__footer .el-button--primary {
      width: 300px;
    }
  }

  .trainPlanRight {
    float: right;
    margin: 10px;

    .el-checkbox {
      color: #000000;
    }

    .addEditRangeButton {
      margin-left: 10px;
      margin-right: 10px;
      border-color: #00c1de;
      background-color: #00c1de;
      color: #fff;
    }

    .courseSelect {
      width: 110px;
      margin: 0 5px;
    }
  }

  .resetPlanButton {
    float: left;
    margin: 10px;
    margin-left: 1%;
    border-color: #00c1de;
  }

  .editCourseDialog {
    .el-dialog {
      border-radius: 12px;
    }

    .dialogNumberInput {
      width: 95px;
      height: 27px;
    }

    .item {
      line-height: 31px;
      font-size: 14px;
      color: #0a2136;
      letter-spacing: 0;
    }

    .noticeItem {
      // text-align: center;
      line-height: 31px;
      font-size: 14px;
      // color: rgba(255, 0, 0, 0.65);
      display: inline-block;
      width: 100%;
      margin-bottom: 10px;
      margin-left: 40px;

      .numberStyle {
        color: #00c1de;
        font-size: 16px;
      }

      .warinigIcon {
        margin: 0 2px 0 -15px;
        color: #00c1de;
      }
    }

    .line {
      height: 1px;
      background-color: #e4e8eb;
      width: 90%;
      margin: 0 auto 10px;
    }

    .el-dialog--center .el-dialog__body {
      padding: 0 10px 10px;
    }

    .operationDialog .el-dialog__footer .el-button--primary {
      width: 300px;
    }

    .ctrlNumberInput {
      width: 40px;

      .el-input {
        display: inline-block;

        input {
          width: 35px;
          height: 30px;
          padding: 0px;
        }
      }
    }
  }

  .resetPlanDialog {
    .el-dialog {
      border-radius: 12px;

      .el-dialog__headerbtn {
        font-size: 23px;
      }
    }

    .el-dialog--center .el-dialog__body {
      max-height: 325px;
      min-height: 150px;
      overflow-y: scroll;
    }

    .el-dialog--center .el-dialog__body {
      padding-bottom: 0;
      padding-top: 10px;
    }

    .resetContent {
      text-align: center;

      .dialogNumberInput {
        width: 95px;
        height: 27px;
      }

      // margin-top: 30px;
      .resetText {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(52, 52, 52, 1);
        line-height: 27px;
      }

      .levelItem {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(80, 86, 89, 1);
        line-height: 22px;

        .ctrlNumberInput {
          width: 55px;
        }
      }

      .line {
        height: 1px;
        background-color: #e4e8eb;
        width: 90%;
        margin: 16px auto 27px;
      }

      .noticeItem {
        width: 307px;
        margin: 20px auto 10px;

        .el-alert__title {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.65);
          line-height: 22px;
        }
      }
    }

    .operationDialog .el-dialog__footer .el-button--primary {
      width: 300px;
    }
  }

  .showProportion {
    .el-dialog {
      border-radius: 12px;
    }
    .el-dialog--center .el-dialog__body {
      padding-bottom: 10px;
      padding-top: 10px;
      height: 400px;
      overflow-y: auto;
    }

    .elRow {
      margin-top: 10px;
    }

    .line {
      height: 1px;
      background-color: #e4e8eb;
      width: 95%;
      margin: 10px auto 10px;
    }

    .dialogNumberInput {
      width: 65px;
      margin-left: 5px;
      margin-right: 5px;
      // height: 27px;
    }

    .title {
      font-size: 16px !important;
      color: #000000 !important;
      width: 100px !important;
    }

    .item {
      // line-height: 31px;
      display: inline-block;
      font-size: 14px;
      color: #595959;
      letter-spacing: 0;
      width: 70px;
    }

    .progress {
      display: inline-block;
      width: 280px;
      line-height: 25px;
      margin-left: 10px;
    }

    .noticeItem {
      margin: 10px auto 10px;
      display: inline-block;
      width: 100%;

      .numberStyle {
        color: #00c1de;
        font-size: 16px;
      }

      .buttonArray {
        display: inline-block;
        margin-left: 10px;
      }
    }
  }

  .submitButton {
    border-color: #00c1de;
    background-color: #00c1de;
  }

  .OperationfaildDialog {
    .Dialog {
      padding-top: 40px !important;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Agent/MyGames.vue